import { UseFormReturnType } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { TRPCClientError } from '@trpc/client';

export function handleFormError<T>(form: UseFormReturnType<T>, error: unknown) {
  console.log(error);
  if (error instanceof TRPCClientError) {
    // Handle Zod validation errors
    if (error.data?.zodError) {
      // Handle field errors
      const { fieldErrors } = error.data.zodError;
      if (fieldErrors) {
        Object.entries(fieldErrors).forEach(([field, messages]) => {
          if (Array.isArray(messages) && messages.length > 0) {
            form.setFieldError(field, messages[0]);
          }
        });
        return;
      }

      // Handle form errors
      const { formErrors } = error.data.zodError;
      if (formErrors.length > 0) {
        notifications.show({
          title: 'Erreur de validation',
          message: formErrors[0],
          color: 'red',
        });
        return;
      }
    }

    // Handle general TRPC error
    notifications.show({
      title: 'Erreur',
      message: error.message ?? 'Une erreur est survenue',
      color: 'red',
    });
    return;
  }
}
